import { render, staticRenderFns } from "./ventilationNew.vue?vue&type=template&id=7ec3f643&scoped=true"
import script from "./ventilationNew.vue?vue&type=script&lang=js"
export * from "./ventilationNew.vue?vue&type=script&lang=js"
import style0 from "./ventilationNew.vue?vue&type=style&index=0&id=7ec3f643&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ec3f643",
  null
  
)

export default component.exports